/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Rule_Min_LengthInputs */

const en_password_reset_rule_min_length = /** @type {(inputs: Password_Reset_Rule_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At least 8 characters`)
};

const es_password_reset_rule_min_length = /** @type {(inputs: Password_Reset_Rule_Min_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al menos 8 caracteres`)
};

/**
* | output |
* | --- |
* | "At least 8 characters" |
*
* @param {Password_Reset_Rule_Min_LengthInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_rule_min_length = /** @type {((inputs?: Password_Reset_Rule_Min_LengthInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Rule_Min_LengthInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_rule_min_length(inputs)
	return en_password_reset_rule_min_length(inputs)
});